import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { CourseService } from '../../services/course.service';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { CreateCourseComponent } from "../../components/course/create-course/create-course.component";
import { DeleteCourseComponent } from "../../components/course/delete-course/delete-course.component";
import { UsersService } from 'src/app/private/services/users.service';

@Component({
  selector: 'app-course-configuration',
  standalone: true,
  imports: [SharedModule, ToolBarComponent, CreateCourseComponent, DeleteCourseComponent],
  templateUrl: './course-configuration.component.html',
  styleUrl: './course-configuration.component.scss'
})
export class CourseConfigurationComponent {
  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10;
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddCourse: boolean = false;
  isEditCourse: boolean = false;
  isDeleteCourse: boolean = false;
  courseData: any;

  columns: any[] = [
    { field: 'name', header: 'Course Name', sortable: true },
    { field: 'code', header: 'Course Code', sortable: true },
    { field: 'duration', header: 'Duration (Months)', sortable: true },
    { field: 'description', header: 'Description', sortable: false },
    { field: 'status', header: 'Status', sortable: true },
    { field: 'actions', header: 'Actions', sortable: false }
  ];

  constructor(
    private api: CourseService,
    private deptApi: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getAllDepartments();
  }

  allDepartments: any[] = [];


  getAllDepartments() {
    const payload = {
      organization_id: this.localStorage.getOrganizationId()
    }
    this.deptApi.getAllDepartment(payload).subscribe({
      next: (res) => {
        this.allDepartments = res || []
        this.allDepartments = this.allDepartments.map((department: any) => {
          return {
            label: department.name,
            value: department.dept_id
          }
        })
      },
      error: (e) => {

      }
    })
  }



  loadData(event: any) {
    this.loading = true;

    const page = event.first || 0;
    const size = event.rows || this.rows;


    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"course\".\"updatedAt\"",
        "dir": "DESC"
      }
    }


    this.api.findAndCountAllCourses(param).subscribe({
      next: (data: any) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Failed to load courses.'
        });
        this.loading = false;
      }
    });
  }

  handleAddCourse() {
    this.isAddCourse = true;
  }

  handleEditCourse(course: any) {
    this.courseData = course;
    this.isEditCourse = true;
  }

  handleDeleteCourse(course: any) {
    this.courseData = course;
    this.isDeleteCourse = true;
  }

  handleCloseAdd(event: any) {
    this.isAddCourse = false;
    if (event) {
      this.loadData({ first: 0, rows: this.rows });
    }
  }

  handleCloseEdit(event: any) {
    this.isEditCourse = false;
    if (event) {
      this.loadData({ first: 0, rows: this.rows });
    }
  }

  handleCloseDelete(event: any) {
    this.isDeleteCourse = false;
    if (event) {
      this.loadData({ first: 0, rows: this.rows });
    }
  }

  reloadTable() {
    this.loadData({ first: 0, rows: this.rows });
  }

  // Context menu items for course actions
  courseActionItems = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => {
        this.handleEditCourse(this.courseData);
      }
    },
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      styleClass: 'delete-menu-item',
      command: () => {
        this.handleDeleteCourse(this.courseData);
      }
    }
  ];

  setCourseData(rowData: any) {
    this.courseData = rowData;
  }
}
